import { render, staticRenderFns } from "./coderInpatientDemographics.vue?vue&type=template&id=07beb0dd&scoped=true&"
import script from "./coderInpatientDemographics.vue?vue&type=script&lang=js&"
export * from "./coderInpatientDemographics.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientDemographics.vue?vue&type=style&index=0&id=07beb0dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07beb0dd",
  null
  
)

export default component.exports